import { getBranchList } from '../../../services/SalaryCards/branch'
import { getBusinessDate } from '../../../services/transfers'
import { Dispatch } from 'redux'
import {
  AppConfigsActions,
  AppConfigsActionTypes,
  BranchListType,
  FetchAppConfigsSuccessAction,
  FetchBusinessDateSuccessAction,
} from 'store/types/configs'
import { setGlobalErrorAction } from '../globalError'
import { GlobalErrorActions } from 'store/types/globalError'

export const fetchBranchListSuccess = (
  data: BranchListType[]
): FetchAppConfigsSuccessAction => ({
  type: AppConfigsActionTypes.FETCH_BRANCH_LIST,
  payload: data,
})

export const fetchBusinessDateSuccess = (data: string): FetchBusinessDateSuccessAction => ({
  type: AppConfigsActionTypes.FETCH_BUSINESS_DATE,
  payload: data,
})

export const fetchBranchList = () => {
  return async (dispatch: Dispatch<AppConfigsActions | GlobalErrorActions>) => {
    try {
      const data = await getBranchList()
      dispatch(fetchBranchListSuccess(data))
    } catch (error) {
      dispatch(setGlobalErrorAction(error.message ?? ''));
    }
  }
}

export const fetchBusinessDate = () => {
  return async (dispatch: Dispatch<AppConfigsActions | GlobalErrorActions>) => {
    try {
      const language = localStorage.getItem('i18nextLng')
      const data = await getBusinessDate(language);
      dispatch(fetchBusinessDateSuccess(data))
    } catch (error) {
      dispatch(setGlobalErrorAction(error.message ?? ''));
    }
  }
}